// API configuration
// Production (pomoducky.net): use /api so Amplify rewrites forward to API Gateway.
// Development: use relative path so the proxy sends requests to the local Express server.

const isProduction = process.env.NODE_ENV === 'production';
const isAmplifyHost = typeof window !== 'undefined' && window.location.hostname.includes('pomoducky.net');

export const API_BASE = isProduction || isAmplifyHost ? '/api' : '';

export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
}
